class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.productUrl = null;
  }

  connectedCallback() {
    this.productUrl = this.dataset.productUrl;

    this.addEventListener('click', this.handleClick);

    // Hover image swap
    const hoverSrc = this.dataset.hoverImage;
    if (hoverSrc) {
      const img = this.querySelector('img');
      if (img) {
        const originalSrc = img.src;
        const originalSrcset = img.srcset || '';

        // Préchargement silencieux
        new Image().src = hoverSrc;

        this.addEventListener('mouseenter', () => {
          img.src = hoverSrc;
          img.srcset = '';
        });

        this.addEventListener('mouseleave', () => {
          img.src = originalSrc;
          img.srcset = originalSrcset;
        });
      }
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick(event) {
    if (event.target instanceof Element) {
      const interactiveElement = event.target.closest(
        'button, input, label, select, [tabindex="1"], a, quick-add-component, add-to-wishlist-button',
      );
      if (interactiveElement) return;
    }

    window.location.href = this.productUrl;
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard);
}